(function () {
  var videos = document.querySelectorAll('[data-sob-bgvideo]');
  if (!videos.length) return;

  videos.forEach(function (video) {
    var tryPlay = function () {
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          var retry = function () {
            video.play();
            document.removeEventListener('touchstart', retry);
            document.removeEventListener('click', retry);
          };
          document.addEventListener('touchstart', retry, { once: true, passive: true });
          document.addEventListener('click', retry, { once: true });
        });
      }
    };

    if (video.readyState >= 2) {
      tryPlay();
    } else {
      video.addEventListener('loadeddata', tryPlay, { once: true });
    }
  });
})();
